import { Box, styled } from "@mui/material";
import { SearchBox } from "@pmag/ui-components";

export const BoxContainer = styled(Box)(({ theme }) => ({
    paddingTop: theme.spacing(6),
    margin: theme.spacing(0, 4, 0, 4),

    [theme.breakpoints.up("md")]: {
        paddingTop: theme.spacing(8),
    },
}));

export const ControlPanel = styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: theme.spacing(6),
    gap: theme.spacing(3),

    [theme.breakpoints.up("md")]: {
        marginBottom: theme.spacing(6),
    },
}));

export const TabContainer = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(8),
}));

export const StyledSearchBox = styled(SearchBox)(({ theme }) => ({
    marginTop: theme.spacing(8),
}));
